// extracted by mini-css-extract-plugin
export default {"notifier":"notifier_notifier__x-g-x","item":"notifier_item__bDZOk"};